// src/pages/partner/PartnerDashboard.js
import { useEffect, useState } from "react";
import { useAuth } from "../login/AuthProvider";
import axios from "axios";
import { backend } from "../../components/apipath";

function PartnerDashboard() {
  const { partner_id, name, account } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!partner_id) return;

    const fetchOrders = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${backend}partner/orders`, {
          params: { partner_id },
        });
        if (res.data.success) {
          setOrders(res.data.list || []);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [partner_id]);

  return (
    <div className="container mt-4">
      <h3 className="mb-3">合作夥伴後台</h3>
      <p>合作夥伴名稱：{name || account}</p>
      <p>專屬優惠碼報名人數：{orders.length} 位</p>

      <hr />

      {loading ? (
        <p>載入中...</p>
      ) : orders.length === 0 ? (
        <p>目前尚未有學員使用您的專屬優惠碼報名。</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-sm table-bordered align-middle">
            <thead>
              <tr>
                <th>辦理時間</th>
                <th>學員姓名</th>
                <th>購買產品</th>
                <th>使用優惠碼</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.order_id}>
                  <td>{o.order_date}</td>
                  <td>{o.student_name}</td>
                  <td>{o.product_name}</td>
                  <td>{o.discount_code}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default PartnerDashboard;
